export default "__VITE_ASSET__DGGLjMBd__"